interface SelectOption { label: string; value: string; }
// { value: '', label: ''}, <- blank object for copypasta

export const sortByOptions: SelectOption[] = [
    { value: '', label: 'Most Recent' },    // Created is default sort on back end
    { value: 'model,asc', label: 'Model (A - Z)' },
    { value: 'model,desc', label: 'Model (Z - A)' },
    { value: 'year,asc', label: 'Year of Manufacture (Ascending)' },
    { value: 'year,desc', label: 'Year of Manufacture (Descending)' },
    { value: 'price,asc', label: 'Asking Price (Low to High)' },
    { value: 'price,desc', label: 'Asking Price (High to Low)' },
    { value: 'manufacturer,asc', label: 'Manufacturer (A - Z)' },
    { value: 'manufacturer,desc', label: 'Manufacturer (Z - A)' }
];



// WEBPACK FOOTER //
// ./src/constants/filter_options.ts